// extracted by mini-css-extract-plugin
export default {"root":"FavoriteButton_root__17Akw","icon":"FavoriteButton_icon__fLSdN","error":"FavoriteButton_error__LCtUY marketplaceTinyFontStyles"};